import script from "./reviewPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewPopup.vue?vue&type=script&setup=true&lang=js"

import "./reviewPopup.vue?vue&type=style&index=0&id=258cff5d&lang=css"

const __exports__ = script;

export default __exports__